export default {
  screens: [
    {
      type: 'intro',
      title: '自然主义',
      content:
        '自然作为源源不竭、丰饶深厚而富有象征意义的灵感源泉，自然主义历来是CHAUMET的一个重要主题。',
      idYt: 'GUF98BCNd3c',
      videoCover: 'world/wild/video.jpg',
      desktop: {
        cover: 'world/wild/cover-1.jpg'
      },
      mobile: {
        cover: 'world/wild/mobile-cover-1.jpg',
        contentStyle: { width: '100%', paddingBottom: '120px' },
        coverStyle: {
          width: '110%',
          top: '87%',
          bottom: '40px',
          left: '0',
          position: 'absolute'
        }
      },
      isCover: true
    },
    {
      type: 'memento',
      img: 'world/wild/memento.jpg',
      content:
        ' 植物、花卉、昆虫等，在珠宝艺匠们的手中幻化为珠宝艺术珍品，尽情诠释着CHAUMET艺术王国中极具象征性的珍贵宝藏。<br><br> 自然主义风格珠宝力量与精美相得益彰，结构与灵动共谱谐曲，彰显珠宝大师的大胆创意及巧夺天工的精湛工艺。',
      cover: 'world/wild/cover-2.jpg',
      isCover: true
    },
    {
      type: 'staircase',
      desktop: {
        leftImg: 'world/wild/staircaseLeft.jpg',
        middleImg: 'world/wild/staircaseMiddle.jpg',
        rightImg: 'world/wild/staircaseRight.jpg',
        cover: 'world/wild/cover-3.jpg'
      },
      mobile: {
        leftImg: 'world/wild/staircaseLeft.jpg',
        middleImg: 'world/wild/staircaseMiddle.jpg',
        rightImg: 'world/wild/staircaseRight.jpg',
        cover: 'world/wild/mobile-cover-3.jpg',
        contentStyle: { width: '90%' },
        coverStyle: {
          width: '85%',
          top: '-15%',
          right: '0',
          left: 'inherit',
          position: 'absolute'
        }
      },
      content:
        '麦穗这一主题自1811年以来经过多次诠释，早在拿破仑帝国时代， CHAUMET创始人尼铎就运用代表丰收与多产的麦穗向谷物女神刻瑞斯致敬，由此创作出一系列经典佳作。',
      isCover: true
    }
  ]
}



// WEBPACK FOOTER //
// ./src/locales/cn/worlds/wild.js